// Helper to replace Next.js useRouter with React Router equivalents
import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useRouter = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  
  return {
    push: (urlOrObject, options = {}) => {
      let targetUrl;
      
      // Handle Next.js-style navigation with pathname and query
      if (typeof urlOrObject === 'object' && urlOrObject.pathname) {
        const { pathname, query = {} } = urlOrObject;
        const searchParams = new URLSearchParams();
        
        // Add query parameters to URL
        Object.entries(query).forEach(([key, value]) => {
          if (value !== undefined && value !== null) {
            searchParams.append(key, String(value));
          }
        });
        
        const queryString = searchParams.toString();
        targetUrl = queryString ? `${pathname}?${queryString}` : pathname;
      } else {
        targetUrl = urlOrObject;
      }
      
      if (options.shallow) {
        navigate(targetUrl, { replace: false });
      } else {
        navigate(targetUrl);
      }
    },
    replace: (url) => navigate(url, { replace: true }),
    back: () => navigate(-1),
    pathname: location.pathname,
    query: {
      ...params,
      ...Object.fromEntries(new URLSearchParams(location.search))
    },
    asPath: location.pathname + location.search,
    route: location.pathname,
    isReady: true // React Router is always "ready"
  };
};

// For Router.push usage
export const Router = {
  push: (url) => {
    window.location.href = url;
  },
  replace: (url) => {
    window.location.replace(url);
  }
};